import * as React from "react";
import './UiSwitcher.scss'

type PropsType = {
  value: boolean;
  onChange: (e: boolean) => void;
}

const UiSwitcher = ({ value, onChange }: PropsType) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.currentTarget.click();
    }
  };

  return (
    <div>
      <label className="switch">
        <input
          checked={value}
          type="checkbox"
          tabIndex={1}
          className="index-element-0"
          onChange={(e) => onChange(e.target.checked)}
          onKeyDown={handleKeyDown}
        />
        <span className="slider round"></span>
      </label>
    </div>
  )
}

export default UiSwitcher;